import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import "./style.scss";
import Edit from "./Edit";
import Save from "./save";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      // A card grid with a headline and two lines of text — what the block loops
      // out. The inline fill:none is required, not redundant: setting
      // `foreground` makes Gutenberg add `.has-colors`, whose `fill: currentcolor`
      // rule beats the fill attribute and would render the icon as a solid blob.
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        style={{ fill: "none" }}
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="3.2" y="4" width="7.6" height="6" rx="1.6" />
        <rect x="13.2" y="4" width="7.6" height="6" rx="1.6" />
        <path d="M3.2 13.2h7.6M13.2 13.2h7.6" />
        <path d="M3.2 16.4h7.6M13.2 16.4h7.6" />
        <path d="M3.2 19.6h4.6M13.2 19.6h4.6" />
      </svg>
    ),
  },
});
